var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-row',{attrs:{"align":"end"}},_vm._l((_vm.items),function(item){return _c('v-col',{key:item.name,staticClass:"flex-grow-1",attrs:{"cols":"6","sm":"3","lg":"2"}},[_c('Devicon',{attrs:{"name":item.name,"icon":item.icon,"to":item.to}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }